import script from "./CalendarTaskDeleteDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarTaskDeleteDialog.vue?vue&type=script&setup=true&lang=js"

import "./CalendarTaskDeleteDialog.vue?vue&type=style&index=0&id=17fd93e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17fd93e4"]])

export default __exports__